import { ChevronDown16 } from '@yunex/yds-icons';
import React from 'react';
import { blue20opacity15 } from '../../../colors/blue';
import { neutral60opacity20 } from '../../../colors/neutral';
import { shape } from '../shape';
import { rem } from '../../../utils/rem';
var indicator = {
    borderRadius: shape === null || shape === void 0 ? void 0 : shape.borderRadius,
    padding: rem(6),
    '&:hover': {
        backgroundColor: neutral60opacity20,
    },
    '&:active': {
        backgroundColor: blue20opacity15,
    },
    '& svg': {
        height: rem(16),
        width: rem(16),
    },
};
export var MuiAutocomplete = {
    defaultProps: { popupIcon: React.createElement(ChevronDown16, null) },
    styleOverrides: {
        root: {
            '& .MuiAutocomplete-endAdornment': {
                top: "calc(50% - ".concat(rem(14), ")"),
            },
        },
        clearIndicator: indicator,
        popupIndicator: indicator,
    },
};
